import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceCreateProjectPortfolioNotificationState = createStateReducer(
  initialState,
  {
    [events.createProjectPortfolioSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createProjectPortfolio",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.createProjectPortfolioFailed]: (state, { error }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "createProjectPortfolio",
          flags: pushIf({
            duplicateName: error.portfolioNameIsNotUnique,
            emptyName: error.portfolioNameIsEmpty,
          }),
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceCreateProjectPortfolioNotificationState };
